import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import SelectFormulaInput from "./SelectFormulaInput";
import { ReactComponent as BottomBorder } from 'static/icons/bottom-slash.svg';
import "./SelectFormula.scss"

const FormulaSelect = ({
  onSelectItem,
  dropdownData,
  isActive = false,
}) => {
  const [active, setActive] = useState(isActive);

  const ref = useRef(null)

  useEffect(() => {
    setActive(isActive);
  }, [isActive]);

  

  return (
    <div className="select_function_input_container" ref={ref} onClick={()=> setActive(true)}>
      <div
      >
        <div
          className={classNames("select_function_input", {
            hidden: active,
          })}
        >
         <BottomBorder/>
        </div>

        {active && (
          <SelectFormulaInput
            refLink={ref}
            initShowDropdown={true}
            onSelectItem={onSelectItem}
            setActive={setActive}
            dropdownData={dropdownData}
          />
        )}
      </div>
    </div>
  );
};

export default FormulaSelect;
